/* unplugin-vue-components disabled */import { render } from "./SwitchBox.vue?vue&type=template&id=0be1d9af&ts=true"
import script from "./SwitchBox.vue?vue&type=script&lang=ts"
export * from "./SwitchBox.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__